<template>
  <div class="md:mx-14 mx-4">
    <div v-if="isLoading">
      <exchange-rate-loader />
    </div>
    <div v-else>
      <exchange-rate-calculator />
      <exchange-rates-table :tableData="filteredExchangeRates" />
      <!-- Dialogs -->
      <app-tour
        :tourDetails="exchangeRateTour"
        tourComponent="exchangeRate"
        :displayTour="displayTour"
        @stopTour="stopTour"
      />
      <initiate-tour-button @startTour="startExchangeRateTour" />
    </div>
  </div>
</template>

<script>
import tenant from '@/mixins/tenant.js'
import { EXCHANGE_RATE_TOUR } from '@/utils/constants'
import fetchAllTours from '@/mixins/appTourApi.js'
import { GetCurrencyCountry } from '@/utils/helpers.js'
export default {
  name: 'ExchangeRates',
  mixins: [tenant, fetchAllTours],
  components: {
    InitiateTourButton: () =>
      import('@/components/v2/app-tour/InitiateTourButton.vue'),
    AppTour: () => import('@/components/v2/app-tour/AppTour.vue'),
    ExchangeRatesTable: () =>
      import('@/components/v2/exchangeRates/tables/ExchangeRatesTable.vue'),
    ExchangeRateCalculator: () =>
      import('@/components/v2/exchangeRates/layout/ExchangeRateCalculator.vue'),
    ExchangeRateLoader: () =>
      import('@/components/v2/skeletalLoaders/ExchangeRateLoader.vue')
  },
  data () {
    return {
      isLoading: false,
      displayTour: false,
      exchangeRateTour: EXCHANGE_RATE_TOUR,
      showFilterDialog: false
    }
  },
  methods: {
    startExchangeRateTour () {
      this.$tours.exchangeRateTour.start()
      this.displayTour = true
    },
    stopTour () {
      this.displayTour = false
    },
    getCurrencyCountry (val) {
      return GetCurrencyCountry(val)
    }
  },
  computed: {
    isANewUser () {
      return !this.$store.state.appTour.allTours.exchangeRate
    }
  },
  async mounted () {
    await this.fetchAllTours()
    if (this.isANewUser) {
      this.startExchangeRateTour()
    }
  }
}
</script>
